import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { indexStore } from "../store/indexStore";
import IsNotActive from "../components/IsNotActive/IsNotActive";
import ResponsiveBranchScreen from "../components/BranchSecrens/ResponsiveBranchScreen";
function Branch() {
  const {
    changeCategory,
    fetchMenusAction,

  } = indexStore();
  const params = useParams();
  useEffect(() => {
    fetchMenusAction({ branch_id: params.branch_id });
    changeCategory(0);
  }, []);

  return (
    <IsNotActive>

      <ResponsiveBranchScreen />
    </IsNotActive>
  );
}

export default Branch;
